"use strict";

exports.__esModule = true;
exports["default"] = exports.IntroductionComponent = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = require("prop-types");

var _ramda = require("ramda");

var _components = require("../../components");

var _description = _interopRequireDefault(require("./description"));

var _files = _interopRequireDefault(require("./files"));

var _gridSystem = _interopRequireDefault(require("../../utils/grid-system"));

var _primitives = _interopRequireDefault(require("../../primitives"));

var _utils = require("../../utils");

var _excluded = ["backgroundColor", "backgroundImage", "bottomPadding", "children", "className", "columnPropotions", "customBackground", "darkUi", "files", "fileTitle", "htmlId", "showFiles", "topPadding"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Pretitle = _styledComponents["default"].span.withConfig({
  displayName: "introduction__Pretitle",
  componentId: "sc-1sc9daa-0"
})(["letter-spacing:4px;text-transform:uppercase;"]); // IE11 hack: fixes issue of child elements overflowing container


var TextContainer = (0, _styledComponents["default"])(_gridSystem["default"].Element).withConfig({
  displayName: "introduction__TextContainer",
  componentId: "sc-1sc9daa-1"
})(["*{max-width:100%;}"]);
var propTypes = {
  /** Background color */
  backgroundColor: _propTypes.string,

  /** Background Image */
  backgroundImage: _propTypes.string,

  /** Bottom padding factor */
  bottomUnitPadding: _propTypes.number,

  /** child elements for panel content */
  children: _propTypes.node,

  /** Component container class name */
  className: _propTypes.string,

  /** setting for column sizes */
  columnPropotions: _propTypes.string,

  /** custom background config for component container */
  customBackground: _propTypes.string,

  /** darkUI toggle config */
  darkUi: _propTypes.bool,

  /** test id for Cypress */
  "data-test-id": _propTypes.string,

  /** Description string text */
  description: _propTypes.string,

  /** Description collapse text */
  descriptionCollapseText: _propTypes.string,

  /** Description expand text */
  descriptionExpandText: _propTypes.string,

  /** Disclaimer */
  disclaimer: _propTypes.node,

  /** Disclaimer color */
  disclaimerColor: _propTypes.string,

  /** File text */
  fileTitle: _propTypes.string,

  /** Files list data */
  files: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    /** filename of each filter group */
    fileName: _propTypes.string.isRequired,

    /** Glyph node */
    glyph: _propTypes.node.isRequired,

    /** Tag for filter group */
    tag: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func]),

    /** URL of each filter group */
    url: _propTypes.string.isRequired
  })),

  /** html element id */
  htmlId: _propTypes.string,

  /** link for the agreement content */
  licenseAgreementPath: _propTypes.string,

  /** Title text for the agreement */
  licenseAgreementText: _propTypes.string,

  /** Number of chars before truncation occurs */
  maxCharCount: (0, _propTypes.oneOfType)([_propTypes.number, (0, _propTypes.arrayOf)(_propTypes.number)]),

  /** Text before title text */
  pretitle: _propTypes.node,

  /** Theme config */
  theme: _utils.themePropType,

  /** Title text */
  title: _propTypes.node,

  /** Title color */
  titleColor: _propTypes.string,

  /** Container padding config */
  topUnitPadding: _propTypes.number
};
var defaultProps = {
  bottomUnitPadding: 2,
  columnPropotions: "one-half",
  titleColor: "title",
  topUnitPadding: 2
};
var licenseContainerStyles = {
  fontSize: 1,
  fontWeight: 1,
  lineHeight: 2,
  mt: 3,
  tag: "div"
};
var licenseAgreementStyles = {
  fontSize: 1,
  fontWeight: 1,
  lineHeight: 2,
  mt: 0,
  rel: "nofollow",
  tag: "a",
  target: "_blank"
};
var font = {
  fontSize: [4],
  fontWeight: 1,
  letterSpacing: "0.5px",
  lineHeight: [3]
};
var titleFont = {
  fontSize: [6, 6, 6, 6, 6, 6],
  fontWeight: 2,
  lineHeight: [2, 2, 1, 1, 1, 1],
  mb: 3,
  textAlign: "left"
};
var textContainerStyles = {
  alignItems: "flex-start",
  columns: [6, 5, 8],
  flexDirection: "column",
  justifyContent: "flex-start"
};
var GridSystemStyles = {
  alignItems: "flex-start",
  flexDirection: ["column", "row", "row"],
  justifyContent: "space-between",
  width: 1
};

var IntroductionUI = function IntroductionUI(_ref) {
  var backgroundColor = _ref.backgroundColor,
      backgroundImage = _ref.backgroundImage,
      bottomPadding = _ref.bottomPadding,
      children = _ref.children,
      className = _ref.className,
      columnPropotions = _ref.columnPropotions,
      customBackground = _ref.customBackground,
      darkUi = _ref.darkUi,
      files = _ref.files,
      fileTitle = _ref.fileTitle,
      htmlId = _ref.htmlId,
      showFiles = _ref.showFiles,
      topPadding = _ref.topPadding,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Wrapper, _extends({
    alignItems: "center",
    backgroundColor: backgroundColor || (darkUi ? "background-dark" : "background"),
    backgroundImage: backgroundImage,
    className: className,
    htmlId: htmlId,
    justifyContent: "center",
    tag: customBackground
  }, props), /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Container, _extends({
    pb: bottomPadding,
    pt: topPadding
  }, GridSystemStyles), /*#__PURE__*/_react["default"].createElement(TextContainer, textContainerStyles, children), /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Element, {
    columns: [0, 0, 1]
  }), showFiles && /*#__PURE__*/_react["default"].createElement(_files["default"], {
    columnPropotions: columnPropotions,
    files: files,
    fileTitle: fileTitle
  })));
};

IntroductionUI.propTypes = {
  /** Background color */
  backgroundColor: _propTypes.string,

  /** Background Image */
  backgroundImage: _propTypes.string,

  /** Bottom padding factor */
  bottomPadding: (0, _propTypes.arrayOf)(_propTypes.number),

  /** child elements for panel content */
  children: _propTypes.node,

  /** Component container class name */
  className: _propTypes.string,

  /** setting for column sizes */
  columnPropotions: _propTypes.string,

  /** custom background config for component container */
  customBackground: _propTypes.string,

  /** darkUI toggle config */
  darkUi: _propTypes.bool,

  /** File text */
  fileTitle: _propTypes.string,

  /** Files list data */
  files: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    /** filename of each filter group */
    fileName: _propTypes.string.isRequired,

    /** Glyph node */
    glyph: _propTypes.node.isRequired,

    /** Tag for filter group */
    tag: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func]),

    /** URL of each filter group */
    url: _propTypes.string.isRequired
  })),

  /** html element id */
  htmlId: _propTypes.string,

  /** should show files window */
  showFiles: _propTypes.bool,

  /** Container padding config */
  topPadding: (0, _propTypes.arrayOf)(_propTypes.number)
};

var IntroductionComponent = function IntroductionComponent(_ref2) {
  var backgroundColor = _ref2.backgroundColor,
      backgroundImage = _ref2.backgroundImage,
      bottomUnitPadding = _ref2.bottomUnitPadding,
      children = _ref2.children,
      className = _ref2.className,
      columnPropotions = _ref2.columnPropotions,
      customBackground = _ref2.customBackground,
      darkUi = _ref2.darkUi,
      _ref2$dataTestId = _ref2["data-test-id"],
      dataTestId = _ref2$dataTestId === void 0 ? "modules-introduction" : _ref2$dataTestId,
      description = _ref2.description,
      descriptionCollapseText = _ref2.descriptionCollapseText,
      descriptionExpandText = _ref2.descriptionExpandText,
      disclaimer = _ref2.disclaimer,
      disclaimerColor = _ref2.disclaimerColor,
      files = _ref2.files,
      fileTitle = _ref2.fileTitle,
      htmlId = _ref2.htmlId,
      licenseAgreementPath = _ref2.licenseAgreementPath,
      licenseAgreementText = _ref2.licenseAgreementText,
      maxCharCount = _ref2.maxCharCount,
      pretitle = _ref2.pretitle,
      theme = _ref2.theme,
      title = _ref2.title,
      titleColor = _ref2.titleColor,
      topUnitPadding = _ref2.topUnitPadding;
  var maxCharacters = (0, _react.useMemo)(function () {
    return (0, _ramda.flatten)([maxCharCount]);
  }, [maxCharCount]);
  var baseMap = (0, _ramda.repeat)("none", (0, _ramda.length)(maxCharacters) - 1);

  var createShowMapping = function createShowMapping(index) {
    return (0, _ramda.insert)(index, "block", baseMap);
  };

  var bottomPadding = (0, _react.useMemo)(function () {
    return theme && theme.unitPadding && theme.unitPadding.map(function (padding) {
      return bottomUnitPadding * padding;
    });
  }, [bottomUnitPadding, theme]);
  var topPadding = (0, _react.useMemo)(function () {
    return theme && theme.unitPadding && theme.unitPadding.map(function (padding) {
      return topUnitPadding * padding;
    });
  }, [topUnitPadding, theme]);
  var textColor = darkUi ? "text-light" : "text-helper";
  var showFiles = (0, _react.useMemo)(function () {
    return !(0, _ramda.isEmpty)(files);
  }, [files]);
  return /*#__PURE__*/_react["default"].createElement(IntroductionUI, {
    backgroundColor: backgroundColor,
    backgroundImage: backgroundImage,
    bottomPadding: bottomPadding,
    className: className,
    columnPropotions: columnPropotions,
    customBackground: customBackground,
    darkUi: darkUi,
    "data-test-id": dataTestId,
    files: files,
    fileTitle: fileTitle,
    htmlId: htmlId,
    showFiles: showFiles,
    topPadding: topPadding
  }, /*#__PURE__*/_react["default"].createElement(_components.PanelContent, {
    tagline: pretitle && /*#__PURE__*/_react["default"].createElement(Pretitle, null, pretitle),
    title: title,
    titleFont: Object.assign({
      color: titleColor
    }, titleFont)
  }), maxCharacters && (0, _utils.mapIndexed)(function (maxCount, index) {
    return /*#__PURE__*/_react["default"].createElement(_description["default"], {
      key: "key" + maxCount + "-" + index,
      charCount: maxCount,
      collapseText: descriptionCollapseText,
      "data-test-id": "modules-introduction-description",
      description: description,
      display: createShowMapping(index),
      expandText: descriptionExpandText,
      font: Object.assign({
        color: darkUi ? "text-light" : "text"
      }, font),
      titleColor: "text-hover"
    });
  }, maxCharacters), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({
    color: disclaimerColor || textColor,
    "data-test-id": "modules-introduction-legal-disclaimer"
  }, licenseContainerStyles), disclaimer, licenseAgreementPath && /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, {
    mt: 1
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({
    color: disclaimerColor || textColor,
    href: licenseAgreementPath
  }, licenseAgreementStyles), licenseAgreementText))), children);
};

exports.IntroductionComponent = IntroductionComponent;
IntroductionComponent.propTypes = propTypes;
IntroductionComponent.defaultProps = defaultProps;
IntroductionComponent.displayName = "Modules.IntroductionComponent";

var _default = (0, _styledComponents.withTheme)(IntroductionComponent);

exports["default"] = _default;